// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-empty-state .ui-empty-state__icon[data-v-2b5e8be6]{margin:32px 0}.ui-empty-state .ui-empty-state__icon i[data-v-2b5e8be6]{font-size:160px}.ui-empty-state .ui-empty-state__label[data-v-2b5e8be6]{margin:16px 0}.ui-empty-state .ui-empty-state__description[data-v-2b5e8be6]{margin:16px 0}\n", ""]);
// Exports
module.exports = exports;
